module.exports = __webpack_public_path__ + "static/img/ST.6db0f216.png";